var _defs, _ellipse, _circle, _circle2, _circle3, _g, _rect, _g2, _circle4, _circle5, _path, _path2, _path3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 200,
    viewBox: "0 0 240 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "accountEmptyHeaderGradient",
    x1: 65,
    y1: 85,
    x2: 175,
    y2: 125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7579E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BD7E2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "accountEmptyCardClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 85,
    width: 110,
    height: 95,
    rx: 14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "accountEmptyAvatarClip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 112,
    r: 20
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 194,
    rx: 58,
    ry: 6,
    fill: "#EBEBEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 150,
    r: 4,
    fill: "#CBCED5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 70,
    r: 3,
    fill: "#CBCED5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 150,
    r: 5,
    fill: "#FFEFB7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#accountEmptyCardClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 85,
    width: 110,
    height: 95,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 85,
    width: 110,
    height: 40,
    fill: "url(#accountEmptyHeaderGradient)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 85,
    width: 110,
    height: 95,
    rx: 14,
    fill: "none",
    stroke: "#CBCED5",
    strokeWidth: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#accountEmptyAvatarClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 92,
    width: 40,
    height: 40,
    fill: "#EAEFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 105,
    r: 8,
    fill: "#7579E7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 130,
    rx: 16,
    ry: 14,
    fill: "#7579E7"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 112,
    r: 20,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 128,
    r: 7,
    fill: "#61D79C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131,128 L133.3,130.3 L137.5,125.5",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90,152 L150,152",
    stroke: "#EBEBEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "1 9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90,166 L135,166",
    stroke: "#EBEBEB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "1 9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 26,
    width: 72,
    height: 56,
    rx: 12,
    fill: "#F6F6F6",
    stroke: "#CBCED5",
    strokeWidth: 1.5,
    strokeDasharray: "4 5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 42,
    width: 46,
    height: 5,
    rx: 2.5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 55,
    width: 36,
    height: 5,
    rx: 2.5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 68,
    width: 26,
    height: 5,
    rx: 2.5,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 26,
    r: 12,
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,20 L224,32 M218,26 L230,26",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountEmpty);
export default __webpack_public_path__ + "static/media/account_empty.3f8a6378411e43088e58709368ec1c91.svg";
export { ForwardRef as ReactComponent };